import React from 'react';
import { NavLink } from 'react-router-dom';
import { IconHome, IconSearch, IconCalendar, IconUser } from '@tabler/icons-react';
import { PATHS } from '../../routes/paths';

const ITEMS = [
  { to: PATHS.home, label: 'Home', Icon: IconHome },
  { to: PATHS.doctors, label: 'Doctors', Icon: IconSearch },
  { to: PATHS.appointments, label: 'Appointments', Icon: IconCalendar },
  { to: PATHS.profile, label: 'Profile', Icon: IconUser },
];

export default function BottomNav() {
  return (
    <nav className="bottom-nav" aria-label="Main">
      {ITEMS.map(({ to, label, Icon }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) => `bottom-nav__item ${isActive ? 'bottom-nav__item--active' : ''}`}
        >
          <Icon size={24} stroke={1.7} />
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
